<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card flat class="text-xs-center ma-1" width="100%" id="vertabla">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Seguimiento {{ clclave }}</span>
                    </v-card-title>
                    <v-card-text>
                        <br />
                        <DataTable v-if="ver" :url="url" :columns="head" :formatterActions="formatterActions"
                            :params="displayInputs" :order="[]" select="multiple" @input="seleccionarReportes"
                            :dom="'Bfrtip'" :todo="false" @SeleccionTabla="SeleccionarTodo" class="tablaEspecial"
                            @apiDT="apiDT = $event">
                        </DataTable>


                    </v-card-text>
                    <v-row justify="center">
                        <v-btn class="ma-2" :disabled="loadingB" @click="Guardar()" color="success">
                            Guardar Seguimiento
                            <template v-slot:loader>
                                <span>Loading...</span>
                            </template>
                        </v-btn>
                        <v-btn class="ma-2" :disabled="loadingB" @click="Eliminar()" color="error">
                            Eliminar Seguimiento
                        </v-btn>
                    </v-row>
                    <br />
                    <br />
                </v-card>
                <v-card flat class="text-xs-center ma-3" width="100%" id="veredicion">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Seguimiento {{ clclave }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">

                                    <span class="text-h6">Reporte: </span>
                                    <span class="text-h6">{{ reporte }}</span>
                                </v-col>
                                <v-col cols="12" md="6" offset-md="3">

                                    <span class="text-h6">Observación:</span>
                                    <v-textarea :counter="255" :rules="rulestextarea" outlined v-model="observacion"
                                        required
                                        v-on:blur="observacion = observacion != null ? observacion.trim() : null"
                                        name="input-7-4"></v-textarea>

                                </v-col>
                            </v-row>
                            <v-row justify="center" class="mb-8">
                                <v-btn @click="GuardarEdiciom()" class="ma-2" color="primary">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn color="default" @click="Limpiar()" class="ma-2">
                                    Limpiar
                                </v-btn>
                                <v-btn color="error" @click="Regresar()" class="ma-2">
                                    Regresar
                                </v-btn>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import General from "@/services/Operacion/Operacion.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import UtilidadesServ from '@/services/Utilidades/Utilidades.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
        DataTable,
    },
    data() {
        return {
            valid: true,
            showcargando: true,
            apiDT: null,
            displayInputs: {},
            url: "Operacion/SeguimientoGNP",
            head: [
                { name: "reporte", data: "reporte", title: "Reporte", },
                { name: "exfecha", data: "exfecha", title: "Fecha" },
                { name: "exfechaabo", data: "exfechaabo", title: "Fecha abo" },
                { name: "svnumave", data: "svnumave", title: "Num. Carpeta" },
                { name: "cegrupo", data: "cegrupo", title: "Tipo" },
                { name: "ceconcepto", data: "ceconcepto", title: "Concepto" },
                { name: "observaciones", data: "observaciones", title: "Observaciones", },
                { name: "tamaño", data: "tamaño", title: "Tamaño Obs" },
                { name: "svnumsin", data: "svnumsin", title: "Num.Siniestro" },
                { name: "uslogin", data: "uslogin", title: "Usuario" },
                { name: "genombre", data: "genombre", title: "Gerencia" },
                { name: "exid", data: "exid", title: "Editar", formatter: [this, "formatearEditar"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "editarObservacion"] }
            ],
            ver: false,
            loadingB: true,
            seleccion: [],
            editar: true,
            reporte: '',
            observacion: '',
            exid: 0,
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 255) {
                            return "Máximo 255 Carácteres"
                        }
                        else
                            return true
                    }
                },
            ],
            clclave: '',
            Fila: 0,
            user: '',
        }
    },
    watch: {
        seleccion() {
            if (this.seleccion.length > 0)
                this.loadingB = false;
            else
                this.loadingB = true;
        }
    },
    methods: {
        SeleccionarTodo(tipo) {
            if (tipo == 1) {
                this.apiDT.rows().select();
                if (this.permisoCausion == false) {
                    this.apiDT.rows('.blocked-row').deselect();
                }
            } else if (tipo == 2) {
                this.apiDT.rows().deselect();
            } else if (tipo == 3) {
                // Invertir selección en toda la tabla
                this.apiDT.rows().every(function () {
                    if (this.nodes().to$().hasClass('selected')) {
                        this.deselect();
                    } else {
                        this.select();
                    }
                });
                this.apiDT.rows('.blocked-row').deselect();

            }
        },
        async GuardarEdiciom() {
            if (this.$refs.form.validate()) {
                this.editar = true;
                let id = this.exid;
                let obsl = this.observacion.length;
                let obs = this.observacion;
                document.getElementsByClassName("Gola" + this.Fila)[0].childNodes[6].innerHTML = this.observacion;
                document.getElementsByClassName("Gola" + this.Fila)[0].childNodes[7].innerHTML = obsl;
                document.getElementById("veredicion").style.display = "none";
                document.getElementById("vertabla").style.display = "";

                this.apiDT.data().map(function (datos) {
                    if (datos.exid == id) {
                        datos.observaciones = obs;
                    }

                    return datos;
                });
            }
        },
        Limpiar() {
            this.$refs.form.reset();
        },
        Regresar() {
            document.getElementById("veredicion").style.display = "none";
            document.getElementById("vertabla").style.display = "";
            this.editar = true;
        },
        async Guardar() {
            let formdata = new FormData();
            formdata.append("parametros", JSON.stringify(this.seleccion));
            formdata.append("clclave", this.clclave);
            this.$swal({
                position: "center",
                title: "Procesando Seguimiento ...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirm: false,
            });
            this.$swal.showLoading();
            await UtilidadesServ.GuardarSeguimento(formdata).then(data => {
                let inf = "";
                let width = '';
                let tabla = '';
                if (data.length > 0) {
                    tabla = "<div style='text-align: center;'><table style='margin: 0 auto;'>";
                    tabla += "<tr><th style='padding: 22px 2px; width: 90px;'>Reporte</th><th style='padding: 12px 1px; text-align: justify'>Seguimiento</th><th style='padding: 12px 10px; text-align: justify'>Mensaje</th><tr>";
                    for (var i = 0; i < data.length; i++) {
                        tabla += "<tr>";
                        tabla += "<td style='padding: 22px 2px; width: 90px;'>" + data[i].nrreporte + "-" + data[i].svindice + "</td>";
                        if (data[i].movimiento != null)
                            tabla += "<td style='padding: 12px 5px; text-align: justify'>" + data[i].movimiento + "</td>";
                        else
                            tabla += "<td style='padding: 12px 5px; text-align: justify'>Expedientes</td>";
                        tabla += "<td style='padding: 12px 10px; text-align: justify'>" + data[i].error + "</td>";
                        tabla += "</tr>";
                    }
                    tabla += "</table></div>"
                    let width = '50em';
                }
                else {
                    tabla = "Actualización realizada correctamente";
                    width = "32em";
                }
                this.$swal({
                    position: "center",
                    title: "Atención",
                    html: tabla,
                    icon: 'info',
                    width: '35em',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                    timer: 4000,
                });

                this.loadingB = true;
                this.seleccion = [];
                this.reloadTable();

            });
        },
        async Eliminar() {
            this.$swal({
                position: "center",
                icon: "warning",
                text: "¿Está seguro que desea eliminar la selección?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    let formdata = new FormData();
                    formdata.append("parametros", JSON.stringify(this.seleccion));
                    formdata.append("uslogin", this.user);
                    this.$swal({
                        position: "center",
                        title: "Procesando Seguimiento ...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirm: false,
                    });
                    this.$swal.showLoading();
                    UtilidadesServ.EliminarSeguimiento(formdata).then(data => {
                        if (data) {
                            this.$swal(
                                "Atención",
                                "Los datos se eliminaron correctamente",
                                'success'
                            );
                            this.loadingB = true;
                            this.seleccion = [];
                            this.reloadTable();
                        }
                        else {
                            this.$swal(
                                "Atención",
                                "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                'info'
                            );
                        }
                    });
                }
                this.reloadTable();
                this.seleccion = [];
            });

        },
        async editarObservacion(params, item, fila) {
            let v = fila[0];
            this.Fila = v[0];

            document.getElementById("veredicion").style.display = "";
            document.getElementById("vertabla").style.display = "none";
            this.editar = false;
            this.exid = item.exid;
            this.reporte = item.reporte;
            this.observacion = item.observaciones;
        },
        formatearTexto(x) {

        },
        formatearEditar(x) {
            return x.exid ? `<button type="button" data-action="0" data-params="${x}" class=" dt-formatterAction v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"><span class="v-btn__content"><span style="color: white;">Editar</span></span></button>` : ``;

        },
        seleccionarReportes(reporte) {
            this.seleccion = reporte;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
    },
    async mounted() {
        document.getElementById("veredicion").style.display = "none";
        this.user = await MetodosGenerales.ObtenerUserName()
        let dato = await MetodosGenerales.obtenerSessionReporte("param");

        this.clclave = dato.clclave
        this.showcargando = false;
        this.displayInputs = {
            clclave: this.clclave,
        };
        this.ver = true;

    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '269').then(response => {

            if (response.data.length > 0) {
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }

        });
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
}
</script>
<style>
.tablaEspecial div.dt-buttons {
    float: right;
}

.tablaEspecial div.dataTables_wrapper div.dataTables_filter {
    text-align: left;
}

.tablaEspecial .dataTables_wrapper .dataTables_filter {
    float: left;
    text-align: left;
}
</style>